import { API_BASE_URL } from "../../config";

const apiBase = () => String(API_BASE_URL || "").replace(/\/$/, "");

/** Share URL for a fixture prediction room (OG → web app). */
export const buildPredictionFixtureShareLink = (fixtureId) => {
  const id = String(fixtureId || "").trim();
  if (!id) return "";
  const base = apiBase();
  if (base) return `${base}/share/predictions/fixture/${encodeURIComponent(id)}`;
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/app/predictions?f=${encodeURIComponent(id)}`;
};

/** Share URL for a community tipster slip. */
export const buildCommunityPredictionShareLink = (tipId) => {
  const id = String(tipId || "").trim();
  if (!id) return "";
  const base = apiBase();
  if (base) return `${base}/share/predictions/community/${encodeURIComponent(id)}`;
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/app/predictions?t=${encodeURIComponent(id)}`;
};

export const buildPredictionFixtureShareText = (entry) => {
  const fixture = entry?.fixture || {};
  const home = fixture.teams?.home?.name || "Home";
  const away = fixture.teams?.away?.name || "Away";
  const crowd = entry?.consensus?.count || 0;
  const hasAi = Boolean(entry?.ai);
  const bits = [];
  if (hasAi) bits.push("AI");
  if (crowd) bits.push(`${crowd} tipster${crowd === 1 ? "" : "s"}`);
  const sources = bits.length ? bits.join(" + ") : "tips";
  return `${home} vs ${away} · ${sources} on BetBond:`;
};

export const buildCommunityPredictionShareText = (tip) => {
  const fixture = tip?.fixture || {};
  const home = fixture.teams?.home?.name || "Home";
  const away = fixture.teams?.away?.name || "Away";
  const creator =
    typeof tip?.user === "object" && tip.user?.name ? tip.user.name : "A tipster";
  const lead = [...(tip?.outcomes || [])].sort(
    (a, b) => (Number(b.confidence) || 0) - (Number(a.confidence) || 0)
  )[0];
  const pick = tip?.isPremium && !lead ? "a premium tip" : lead?.outcome || "a tip";
  return `${creator} on ${home} vs ${away} · ${pick}. Open on BetBond:`;
};
